export default function setCityAction(city) {
    return {
        type: 'SET_CITY',
        payload: city
    }
}
